

<template>
  <div class="PortfolioList">
    <div class="PortfolioItemWarp" v-for="v in teamList" :key="v.id">
      <div class="PortfolioItem" @click="goDetail(v)">
        <img :src="v.avatar" alt="">
        <div class="teamInfo">
          <div class="name fOH">{{v.nickname}}</div>
          <div class="desc fOR">{{v.zw_name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    isHome: {
      type:Boolean,
      default() {
        return false;
      }
    },
    teamList:{
      type:Array,
      default(){
        return []
      }
    }
  },
  data(){
    return {
    }
  },
  methods:{
    async goDetail(v){
      await this.$store.dispatch('setStoreByKeyData',{key:'setTeamInfo',data:v})
      if(this.isHome){
        return this.$emit('goDetail',true)
      }
      this.$router.push({name:'TeamDetail',query:{id:v.id}})
    }
  }
}
</script>
<style scoped lang="scss">
.PortfolioList{
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: -1rem;
  .PortfolioItemWarp{
    width: 12rem;
    padding-top: 1rem;
    box-sizing: border-box;
    .PortfolioItem{
      cursor: pointer;
      position: relative;
      img{
        width: 100%;
        transition: .8s;
      }
      .teamInfo{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-direction: column;
        padding-bottom: .5rem;
        box-sizing: border-box;
        background: transparent;
        background: linear-gradient(0deg, #255DB2 0%, transparent 40%);
        .name{
          //margin-top: 1rem;
          font-size: .9rem;
          color: #fff;
          text-align: center;
        }
        .desc{
          text-align: center;
          margin-top: .2rem;
          color: #fff;
          font-size: .65rem;
        }
      }
    }
  }
}
</style>
